export enum DeviceTokenSteps {
    getCode,
    gettingToken,
    gotToken,
}
